let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gAwiy")).then(() => parcelRequire('ge3HX'));